import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import DEFAULT_CONTENT from "./defaults.js";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mediaUrl = (src) =>
  !src ? "" : src.startsWith("http") || src.startsWith("data:") ? src : `${process.env.REACT_APP_BACKEND_URL}/api/media/${src}`;

const isPlainObject = (v) => v !== null && typeof v === "object" && !Array.isArray(v);

export const deepMerge = (base, over) => {
  if (over === undefined || over === null) return base;
  if (!isPlainObject(base) || !isPlainObject(over)) return over;
  const out = { ...base };
  for (const k of Object.keys(over)) out[k] = deepMerge(base[k], over[k]);
  return out;
};

const SiteContentContext = createContext({ content: DEFAULT_CONTENT });

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then(({ data }) => setContent(deepMerge(DEFAULT_CONTENT, data)))
      .catch(() => {});
  }, []);

  useEffect(() => {
    const logo = content.brand?.logo;
    if (!logo) return;
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = mediaUrl(logo);
  }, [content]);

  return <SiteContentContext.Provider value={{ content }}>{children}</SiteContentContext.Provider>;
};

export const useSiteContent = () => useContext(SiteContentContext);
